import React, { useEffect, useMemo, useRef, useState } from "react";
import FlexBox from "schoolUiComponents/basic/Box/FlexBox";
import { Colors } from "baseStyles/enums/colors";
import Text from "schoolUiComponents/basic/Text";
import { Banner } from "schoolUiComponents/Banner";
import PositionBox from "schoolUiComponents/basic/Box/PositionBox";
import { history } from "../history";
import Input from "schoolUiComponents/basic/Input";
import ForgetPasswordStyles from "./style";
import Box from "schoolUiComponents/basic/Box";
import Button from "schoolUiComponents/basic/Button";
import { APIS } from "../api";
import { REFERRER_PAGE_MAP } from "../../utility/referrer";
import { interactedResetPasswordScreenEvent, viewedResetPasswordScreenEvent } from "../events";

const getParams = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get("token");

    try {
        return token ? JSON.parse(atob(token)) : {};
    } catch (e) {
        console.error(e);
    }
    return {};
}

export const ForgetPassword = () => {
    const params = getParams() || {};
    //@ts-ignore
    const email = params?.masked_email || window.parentEmail;
    const [parentEmail, setParentEmail] = useState<string | null>(email);
    const [error, setError] = useState(null);
    const styles = ForgetPasswordStyles();
    const emailFieldDirty = useRef(false);
    const [inputMethod, setInputMethod] = useState('');
    const [isTyping, setIsTyping] = useState(false);
    const isEmailUpdated = useMemo(() => parentEmail !== email, [parentEmail]);

    useEffect(() => {
            const referrerPage = REFERRER_PAGE_MAP[params?.referrer_code] || "default";
            const invitationSource = params?.referral_type || "";
            viewedResetPasswordScreenEvent({ referrerPage: referrerPage, invitationSource: invitationSource})
        },[])

    const isEmailValid = () => {
        const pEmail = parentEmail?.trim();
        const emailRegex = /^[a-zA-Z0-9,!#\$%&'\*\+\/=\?\^_`\{\|}~-]+(\.[a-zA-Z0-9,!#\$%&'\*\+\/=\?\^_`\{\|}~-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.([a-zA-Z]{2,})$/;
        if (!pEmail?.length) {
            setError("Enter parent's email");
            return false;
        }
        if (!emailRegex?.test(pEmail)) {
            setError("Email is invalid");
            return false;
        }
        setError(null);
        return true;
    }

    const backHandler = () => {
        history.goBack();
        interactedResetPasswordScreenEvent({ clickedOn: "Back button", isEmailUpdated: isEmailUpdated ? "1" : "0" });
    }

    const handleResetNow = (event: any) => {
        event?.stopPropagation();
        event?.preventDefault();
        if (!isEmailValid()) {
            return;
        }
        interactedResetPasswordScreenEvent({ clickedOn: "Reset now", isEmailUpdated: isEmailUpdated ? "1" : "0" });
        const { referral_type, referrer_code, trd_id, user_id } = params || {};
        const pEmail = parentEmail?.trim();
        APIS.forgetPassword({parentEmail: user_id ? user_id : pEmail, referral_type, referrer_code, trd_id}).then((res) => {
            if (res.data) {
                const script = document.createElement("script");
                script.innerHTML = res.data;
                document.body.appendChild(script);
            } else {
                setError('Something went wrong!')
            }
        }).catch((error) => {
            setError(error?.response?.data?.error_message || 'Something went wrong!')
        })
    }

    const sendEventOnPaste = (parentEmail: string) => {
        setInputMethod('pasted');
        interactedResetPasswordScreenEvent({ clickedOn: "Email", interactionDetails: "Copy pasted", isEmailUpdated: (parentEmail !== email) ? "1" : "0" });
    }

    const onChangeEmailEvent = (parentEmail: string) => {
        if (!isTyping && (inputMethod !== 'pasted')) {
            interactedResetPasswordScreenEvent({ clickedOn: "Email", interactionDetails: "Started typing", isEmailUpdated: (parentEmail !== email) ? "1" : "0" });
            setIsTyping(true);
        }
    }

    return (
        <FlexBox dataTestId="forget-password" fullWidth backgroundColor={Colors.WHITE} minHeight={`${window.innerHeight - 61}px`} column relative>
            {(history.length > 2) && <PositionBox.absolute onClick={backHandler} left={34} top={36}><Text.H2 color={Colors.PURE_PURPLE} hoverColor={Colors.NAVY_BLUE}><i style={{ fontSize: '18px' }} className="iconcust-iconBackBtn"></i></Text.H2></PositionBox.absolute>}
            <FlexBox flex={1} center fullWidth>
                <form onSubmit={handleResetNow} autoComplete="on">
                    <FlexBox {...styles.mainBox} center column>
                        <FlexBox fullWidth gap={8} column>
                            <Text.H1 center fontWeight={700}>Reset password</Text.H1>
                            <Banner fullWidth={true}>You can only reset your password if you are a parent or a teacher.</Banner>
                        </FlexBox>
                        <FlexBox gap={8} margin={"8px 0 0 0"} column fullWidth alignStart>
                            <Input disabled={params?.masked_email && params?.user_id} onBlur={isEmailValid} color={Colors.DARK_GREY} hasError={error} value={parentEmail} onChange={(e) => {
                                emailFieldDirty.current = true;
                                setParentEmail(e.target?.value);
                                onChangeEmailEvent(e.target?.value);
                            }}
                            onClick={() => interactedResetPasswordScreenEvent({ clickedOn: "Email", isEmailUpdated: isEmailUpdated ? "1" : "0" })}
                            onPaste={(e) => sendEventOnPaste(e.clipboardData?.getData('text'))}
                                width={styles.mainBox.width} customPlaceholder placeholder="Parent email" padding={"16px 24px"} autoFocus />
                            {!!error?.length && <Box padding={"0 24px"} fullWidth><Text.SMALL color={Colors.DARK_RED_2} lines={3} fullWidth><span dangerouslySetInnerHTML={{ __html: error }} /></Text.SMALL></Box>}
                        </FlexBox>
                        <Button primary onClick={handleResetNow}><Text.H4 color={Colors.WHITE}>Reset now</Text.H4></Button>
                    </FlexBox>
                </form>
            </FlexBox>
        </FlexBox>
    )
}